import { GlobalState } from "little-state-machine";

export const resetState = (state: GlobalState) => ({
  ...state,
  username: undefined,
  userRole: undefined,
  menuItems: undefined,
  loggingOut: undefined,
  selectedHwrcSite: undefined,
  editRegionRequest: undefined,
  systemSettings: undefined,
  editVehicleRequest: undefined,
  editProviderRequest: undefined
});
